import { testMatchesTab } from "./testMatchesTab";

/**
 * @param {object | null | undefined} test
 * @returns {string}
 */
export function courseTestTitle(test) {
  if (typeof test?.titulo === "string" && test.titulo.trim()) {
    return test.titulo.trim();
  }
  if (typeof test?.nombre === "string" && test.nombre.trim()) {
    return test.nombre.trim();
  }
  if (typeof test?.tema === "string" && test.tema.trim()) {
    return test.tema.trim();
  }
  return "";
}

/**
 * Course tests that can be linked from Documents, regardless of their Tests-tab label.
 * Matching the open syllabus tab are listed first so the usual case stays on top.
 *
 * @param {object[] | null | undefined} courseTests
 * @param {string} [selectedTabLabel]
 * @returns {object[]}
 */
export function listLinkableCourseTests(courseTests, selectedTabLabel = "") {
  const seen = new Set();
  /** @type {object[]} */
  const matching = [];
  /** @type {object[]} */
  const others = [];

  for (const test of Array.isArray(courseTests) ? courseTests : []) {
    const titulo = courseTestTitle(test);
    if (!titulo || seen.has(titulo)) {
      continue;
    }
    seen.add(titulo);
    if (selectedTabLabel && testMatchesTab(test, selectedTabLabel)) {
      matching.push(test);
    } else {
      others.push(test);
    }
  }

  return [...matching, ...others];
}
